import api from "src/shared/api";

const partnerSidebarMenuLinksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPermissions: build.query({
      query: () => {
        return {
          url: `/api/user-context/me`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetPermissionsQuery } = partnerSidebarMenuLinksApi;
